<template>
  <div>
    <v-container>
      <v-textarea
        class="mt-1 mb-n7"
        filled
        v-model="powerTranslateRes"
        no-resize
        counter
        height="400"
        hide-details="auto"
        color="cyan"
      ></v-textarea>
    </v-container>
    <v-container class="mt-6 d-flex justify-end">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="cyan darken-1" v-bind="attrs" v-on="on" class="mx-1 mt-n2" icon @click="handleCopy">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("message.PowerTranslate_Copy") }}</span>
      </v-tooltip>
    </v-container>
  </div>
</template>

<script>
import {marked} from 'marked';
import DOMPurify from 'dompurify';
export default {
  name: 'PowerTranslateRight',
  data() {
    return {
      powerTranslateRes: '',
    }
  },
  created() {
    this.$store.watch(
      (state) => state.powerTranslateMsg.powerTranslateRes, () => {
        this.powerTranslateRes = this.$store.getters.getpowerTranslateRes;
      }, {
        deep: true
      }
    );
    this.powerTranslateRes = this.$store.getters.getpowerTranslateRes;
  },
  mounted() {

  },

  methods: {
    htmlfy(answer) {
      // console.log(DOMPurify.sanitize(marked.parse(answer)))
      return DOMPurify.sanitize(marked.parse(answer));      
    },
    handleCopy() {
      const anwser=this.htmlfy(this.powerTranslateRes)
      const temp = document.createElement('div');
      temp.innerHTML =anwser ;
      document.body.appendChild(temp);
      const range = document.createRange();
      range.selectNode(temp);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      document.body.removeChild(temp);
      this.$store.commit('HandlePromptBoomSnackBar', 'Copied')
    }
  }

};
</script>

<style scoped>
</style>